import {
  AvailableProducts,
  EnergyManagementProducts,
  SustainabilityProducts,
  EnergyTypeProducts,
  ProductSelectionValue,
  SelectedProductsMap,
} from '../types';

export const energyManagementProducts: EnergyManagementProducts[] = [
  'enc_slimterugleveren',
  'enc_slimmeenergiesturing',
  'enc_batterij',
];
export const sustainabilityProducts: SustainabilityProducts[] = [
  'enc_elektrischladen',
  'enc_eboiler',
  'enc_warmtepomp',
  'enc_zonnepanelen',
  'enc_vastgoedverduurzamen',
];
export const energyTypeProducts: EnergyTypeProducts[] = ['enc_elektriciteitgas'];

export const availableProducts: AvailableProducts[] = [
  ...energyManagementProducts,
  ...sustainabilityProducts,
  ...energyTypeProducts,
  'enc_ietsanders',
];

export const isProductSelectedValue = (productValue?: ProductSelectionValue): boolean => productValue === '1';

export const isProductSelected = (selectedProducts: SelectedProductsMap, product: AvailableProducts): boolean => {
  return isProductSelectedValue(selectedProducts[product]);
};

export const createSelectedProductsMap = (selectedProducts: AvailableProducts[]): SelectedProductsMap => {
  return availableProducts.reduce((map, product) => {
    map[product] = selectedProducts.includes(product) ? '1' : '0';
    return map;
  }, {} as SelectedProductsMap);
};

const getSelectedProductsByType = <T extends AvailableProducts>(
  selectedProducts: SelectedProductsMap,
  products: T[],
): T[] => {
  return products.filter(product => isProductSelected(selectedProducts, product));
};

export const getEnergyManagementProducts = (selectedProducts: SelectedProductsMap): EnergyManagementProducts[] => {
  return getSelectedProductsByType(selectedProducts, energyManagementProducts);
};

export const getSustainabilityProducts = (selectedProducts: SelectedProductsMap): SustainabilityProducts[] => {
  return getSelectedProductsByType(selectedProducts, sustainabilityProducts);
};

export const getEnergyTypeProducts = (selectedProducts: SelectedProductsMap): EnergyTypeProducts[] => {
  return getSelectedProductsByType(selectedProducts, energyTypeProducts);
};

const productParamMap: Record<string, AvailableProducts> = {
  Warmtepomp: 'enc_warmtepomp',
  Zonnepanelen: 'enc_zonnepanelen',
  'Vastgoed Verduurzamen': 'enc_vastgoedverduurzamen',
  'Slim terugleveren': 'enc_slimterugleveren',
  Batterij: 'enc_batterij',
  'Slimme Energiesturing': 'enc_slimmeenergiesturing',
};

export const getProductFromParam = (product: string): AvailableProducts | undefined => productParamMap[product];
